import { action, mutator } from 'satcheljs';
import type { ComposeViewState } from 'owa-mail-compose-store';
import { type MailRibbonTabId } from 'owa-ribbon-ids/lib/mailRibbonId';
import { setSelectedTab } from 'owa-mail-ribbon-store/lib/store/store';
import { isAccountFeatureEnabled } from 'owa-feature-flags/lib/utils/isFeatureEnabled';

export interface OnComposeRenderedActionMessage {
    viewState: ComposeViewState;
    isRendered: boolean;
    targetWindow: Window;
}
const onComposeRendered: (
    viewState: ComposeViewState,
    isRendered: boolean,
    targetWindow: Window
) => OnComposeRenderedActionMessage = action(
    'OnComposeRendered',
    (
        viewState: ComposeViewState,
        isRendered: boolean,
        targetWindow: Window
    ): OnComposeRenderedActionMessage => ({
        viewState,
        isRendered,
        targetWindow,
    })
);

mutator(onComposeRendered, ({ viewState, isRendered }) => {
    if (viewState.isComposeRendered != isRendered) {
        viewState.isComposeRendered = isRendered;
    }
});

mutator(onComposeRendered, ({ viewState, targetWindow }) => {
    if (
        viewState.mailMergeViewState.isMailMerge &&
        isAccountFeatureEnabled('cmp-mail-merge-v2', viewState.mailboxInfo)
    ) {
        // Skip for mail merge drafts: restoreMailMergeUiForDraft selects the Mail Merge tab
        // asynchronously, and forcing Tab_Message here would race with and clobber that selection.
        return;
    }
    setSelectedTab(10, targetWindow);
});

export default onComposeRendered;
